import React, { useEffect } from "react";
import { Form, Input, Select } from "antd";
import FormItem from "components/fields/FormItem";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getAwardDetails,
  doAwardCreate,
  doAwardUpdate,
} from "../../../../redux/award/awardState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { COLOR_OPTIONS } from "../../../../variables/constants"; 
import { displayIcon, USABLE_ICONS } from "variables/icons";
import { MODULE_AWARDS } from "variables/modules";

const AwardForm = ({
  onCancel,
  submitLabel,
  ...props
}) => {
  const [form] = Form.useForm();
  const { recordId, mode } = props;

  const dispatch = useDispatch();
  const recordData = useSelector((state) => state.award.awardDetails?.data); 

  const getRecord = (id) => dispatch(getAwardDetails(id));
  const doCreate = (data) => dispatch(doAwardCreate(data));
  const doUpdate = (data) => dispatch(doAwardUpdate(data));


  useEffect(() => {
    if (recordId) dispatch(getAwardDetails(recordId));
  }, [dispatch, recordId]);

  useEffect(() => {
    if (recordData) {
      form.resetFields();
      const initialValues = {
        awd_id: recordData?.awd_id ?? "",
        awd_title: recordData?.awd_title ?? "",
        awd_description: recordData?.awd_description ?? "",
        awd_icon: recordData?.awd_icon ?? "",
        awd_color_class: recordData?.awd_color_class ?? "",
      };
      form.setFieldsValue(initialValues);
    }
  }, [recordData, form]);

  const onSubmit = (formData) => {
    try {
      recordData?.awd_id > 0 ? doUpdate(formData) : doCreate(formData);
    } catch (error) {
      console.error("Save failed:", error);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onSubmit}
      className={mode !== "view" ? "form" : ""}
    >
      <FormItem name="awd_id" hidden>
        <Input type="hidden" />
      </FormItem>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-y-2 gap-x-4 w-full">
        <FormItem
          name="awd_title"
          label="Award Title"
          rules={[requiredField]}
          className="col-span-1"
        >
          {mode !== "view" ? (
            <Input
              id="awd_title"
              placeholder="Enter award title"
              className="input-field"
              maxLength={100}
            />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.awd_title}
            </label>
          )}
        </FormItem>

        <FormItem
          name="awd_description"
          label="Description"
          rules={[requiredField]}
          className="col-span-1 md:col-span-2"
        >
          {mode !== "view" ? (
            <Input
              placeholder="Enter description"
              className="input-field"
              maxLength={300}
            />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.awd_description}
            </label>
          )}
        </FormItem>

        <FormItem
          name="awd_icon"
          label="Icon"
          rules={[requiredField]}
          className="col-span-1"
        >
          {mode !== "view" ? (
            <Select
              placeholder="Select icon"
              className="input-field"
              showSearch
              allowClear
              options={Object.keys(USABLE_ICONS).map((key) => ({
                label: (
                  <div className="flex items-center gap-2">
                    {displayIcon(key, "w-4 h-4 muted-text")}
                    <span>{key}</span>
                  </div>
                ),
                value: key,
              }))}
            />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.awd_icon}
            </label>
          )}
        </FormItem>

        <FormItem
          name="awd_color_class"
          label="Color"
          rules={[requiredField]}
          className="col-span-1"
        >
          {mode !== "view" ? (
            <Select
              placeholder="Select color"
              className="input-field"
              options={COLOR_OPTIONS}
            />
          ) : (
            <label className="text-base label-value dark:text-white">
              {recordData?.awd_color_class}
            </label>
          )}
        </FormItem>
      </div>

      <div className="w-full flex justify-end">
        {(mode === "edit") && (
          <CrudButtons
            mode={mode}
            recordId={recordData?.awd_id ?? 0}
            isModal={true}
            modalId={recordData?.awd_id > 0 ? "edit_award" : "add_award"}
            cancelLabel="Cancel"
            viewMode="modal"
            doHideModal={onCancel}
            submitLabel={submitLabel}
            moduleId={MODULE_AWARDS}
          />
        )}
      </div>
    </Form>
  );
};

export default AwardForm;
